import type { FC } from 'react';
import { memo } from 'react';
import { useRoutes } from 'react-router-dom';
import { Layout } from '../layout';
import { useAppRoutes } from './hooks';

export const Router: FC = memo(() => {
  const { appRoutes } = useAppRoutes();

  return useRoutes(
    appRoutes.map((route) => ({
      path: route.path,
      element: <Layout component={route.element} />
    }))
  );
});
